import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import Messages from '../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddMealPeriod extends Component {
    state = {
        type: 'add',
        mealPeriodId: '',
        mealPeriodCode: '',
        mealPeriodName: '',
        startTime: null,
        endTime: null,
        isActive: true,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        const type = this.props.match.params.type;

        this.setState({ type });

        if (type !== "add") {
            this.props.getMasterTableList('res/GetresMealPeriodList', this.state.CompanyId);
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.tableLists !== prevProps.tableLists && this.state.type !== 'add') {

            const id = this.props.match.params.id;
            const list = Array.isArray(this.props.tableLists)
                ? this.props.tableLists
                : (this.props.tableLists ? [this.props.tableLists] : []);

            const MealPeriod = list.find(item => String(item.mealPeriodId) === String(id));

            if (!MealPeriod) return;

            this.setState({
                mealPeriodId: MealPeriod.mealPeriodId || "",
                mealPeriodCode: MealPeriod.mealPeriodCode || "",
                mealPeriodName: MealPeriod.mealPeriodName || "",
                startTime: MealPeriod.startTime || null,
                endTime: MealPeriod.endTime || null,
                isActive: MealPeriod.isActive,
            });
        }
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onCalendarChange = (name, value) => {
        this.setState({
            [name]: value,
            touch: true
        });
    }

    add = () => {

        const formatTime = (value) => {
            if (!value) return '';
            if (typeof value === 'string') return value;

            const pad = (num) => String(num).padStart(2, '0');
            return `${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}`;
        };

        if (this.state.mealPeriodCode === null || this.state.mealPeriodCode.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Meal Period Code is required' });
            return;
        } else if (this.state.mealPeriodName === null || this.state.mealPeriodName.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Meal Period Name is required' });
            return;
        } else if (this.state.startTime === null || this.state.startTime === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Start Time is required' });
            return;
        } else if (this.state.endTime === null || this.state.endTime === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'End Time is required' });
            return;
        }

        var data = {
            companyId: this.state.CompanyId,
            mealPeriodCode: this.state.mealPeriodCode,
            mealPeriodName: this.state.mealPeriodName,
            startTime: formatTime(this.state.startTime),
            endTime: formatTime(this.state.endTime),
            isActive: this.state.isActive,
        }

        if (this.state.type === 'edit') {
            data.mealPeriodId = this.state.mealPeriodId;
        }

        this.props.processDynamicData('ResMealPeriod', this.state.type, data, 'res/GetresMealPeriodList?' + Companyid);

    }

    resetData = () => {
        var data = {
            type: 'add',
            mealPeriodId: '',
            mealPeriodCode: '',
            mealPeriodName: '',
            startTime: null,
            endTime: null,
            isActive: true,
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/mealperiodlist/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let isViewMode = this.state.type === 'view';
        let isEnabled = (this.state.touch === true);

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Meal Period</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Meal Period Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="mealPeriodCode" placeholder="Meal Period Code" value={this.state.mealPeriodCode} onChange={this.change} disabled={isViewMode} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Meal Period Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="mealPeriodName" placeholder="Meal Period Name" value={this.state.mealPeriodName} onChange={this.change} disabled={isViewMode} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Start Time <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Calendar className="p-col-12" placeholder="Start Time" timeOnly showTime value={this.state.startTime} onChange={(e) => this.onCalendarChange('startTime', e.value)} disabled={isViewMode} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">End Time <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Calendar className="p-col-12" placeholder="End Time" timeOnly showTime value={this.state.endTime} onChange={(e) => this.onCalendarChange('endTime', e.value)} disabled={isViewMode} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Is Active :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.isActive} value={this.state.isActive} name="isActive" onChange={this.change} disabled={isViewMode} />
                                </div>

                            </div>
                            <div className="p-col-12 p-lg-12">

                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/mealperiodlist/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMealPeriod);
